import { getBaseUrl } from '@hopin-team/dashboard-constants';
import axios, { AxiosResponse } from 'axios';
import { camelizeKeys } from 'humps';

const getOrganizationsURL = () => {
  return `${getBaseUrl()}/api/v3/app_store_component/organizations`;
};

const API_BASE_v3 = getOrganizationsURL();
const TRAY_API = `${getBaseUrl()}/api/v1/organisers`;
const REGISTRATIONS_API = `${getBaseUrl()}/api/v1/registrations_component`;

const mainAPI = axios.create({
  baseURL: API_BASE_v3,
});

const trayAPI = axios.create({
  baseURL: TRAY_API,
});

// Internal, organization-scoped registrations endpoints authenticated with the
// dashboard user token. Replaces the External API for Bank Questions, which
// required an External API token and the :external_api payment plan feature.
const registrationsAPI = axios.create({
  baseURL: REGISTRATIONS_API,
});

const setAuthHeader = (authenticationToken: string) => {
  mainAPI.defaults.headers.common[
    'Authorization'
  ] = `Bearer ${authenticationToken}`;
  trayAPI.defaults.headers.common[
    'Authorization'
  ] = `Bearer ${authenticationToken}`;
  registrationsAPI.defaults.headers.common[
    'Authorization'
  ] = `Bearer ${authenticationToken}`;
};

mainAPI.interceptors.response.use((response: AxiosResponse) => {
  if (
    response.data &&
    response.headers['content-type'] === 'application/json'
  ) {
    response.data = camelizeKeys(response.data);
  }
  return response;
});

trayAPI.interceptors.response.use((response: AxiosResponse) => {
  if (
    response.data &&
    response.headers['content-type'] === 'application/json'
  ) {
    response.data = camelizeKeys(response.data);
  }
  return response;
});

registrationsAPI.interceptors.response.use((response: AxiosResponse) => {
  const contentType = response.headers['content-type'];
  const mediaType =
    typeof contentType === 'string'
      ? contentType.split(';', 1)[0].trim().toLowerCase()
      : undefined;

  if (response.data && mediaType === 'application/json') {
    response.data = camelizeKeys(response.data);
  }
  return response;
});

export { mainAPI, registrationsAPI, setAuthHeader, trayAPI };
